<template>
	<div class="PosFrase">
		<img v-if="tipoImagen=='Rojo'" src="../assets/ImagenesPagina/electro fitness rojo.png">
		<img v-else src="../assets/ImagenesPagina/electro fitness.png">
	</div>
</template>

<script>
export default {
	name:'frase-electro',
	props: ['tipoImagen']
}
</script>

<style>
	.PosFrase{
		position: relative;
	}

	.PosFrase img{
		position: absolute;
		width: 30vw;
		bottom: -4vw;
	}

</style>